import { useNavigate } from 'react-router-dom'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'

import { AcButton, IAcButton } from '@components'
import { LABELS } from '@constants'
export interface IAcBackButton {
  variant?: IAcButton['variant']
  withIcon?: boolean
  href?: string
}

export const AcBackButton = ({
  variant = 'primary',
  withIcon = false,
  href,
}: IAcBackButton) => {
  const navigate = useNavigate()

  return (
    <AcButton
      onClick={href ? undefined : () => navigate(-1)}
      href={href}
      variant={variant}
      startIcon={withIcon && <ArrowBackOutlinedIcon />}>
      {LABELS.BACK}
    </AcButton>
  )
}
